import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { images } from "../assets/images";

import { DialogContextType } from "../../DialogComponents/FullScreenDialog";

// eslint-disable-next-line max-lines-per-function
export const useContext = (byGeometry?: boolean): DialogContextType => {
  const { t } = useTranslation("dialogs");

  const help: DialogContextType["help"] = useMemo(
    // eslint-disable-next-line max-lines-per-function
    () =>
      byGeometry
        ? {
            hintsBlock: {
              title: t("tableReferences.howItWorksDescription"),
              hints: [
                {
                  img: images.byGeometryStart,
                  label: t("tableReferences.layersStart"),
                },
                {
                  icon: "arrow_forward",
                },
                {
                  img: images.byGeometryMiddle,
                  label: t("tableReferences.layersGeometryIntersection"),
                },
                {
                  icon: "arrow_forward",
                },
                {
                  img: images.byGeometryFinal,
                  label: t("tableReferences.layersReferencesResult"),
                },
              ],
            },
          }
        : {
            hintsBlock: {
              title: t("tableReferences.howItWorksDescription"),
              hints: [
                {
                  img: images.byAttributeStart,
                  label: t("tableReferences.layersStart"),
                },
                {
                  icon: "arrow_forward",
                },
                {
                  img: images.byAttributeMiddle,
                  label: t("tableReferences.layersReferences"),
                },
                {
                  icon: "arrow_forward",
                },
                {
                  img: images.byAttributeFinal,
                  label: t("tableReferences.layersReferencesResult"),
                },
              ],
            },
          },
    [byGeometry, t],
  );

  return useMemo(
    () => ({
      title: {
        text: t("tableReferences.tableAttributesJoin"),
        icon: "table",
      },
      attributes: {
        label: t("editResource.attributes"),
        description: t("tableReferences.attributesHint"),
        icon: "table",
        addAttribute: t("addAttribute", { ns: "common" }),
      },
      help,
    }),
    [t, help],
  );
};
